const META_KEY = 'impersonation_meta';
const TOKEN_KEY = 'impersonation_access_token';

export function getImpersonationMeta() {
  try {
    const raw = sessionStorage.getItem(META_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setImpersonationSession(meta, accessToken) {
  sessionStorage.setItem(META_KEY, JSON.stringify(meta));
  if (accessToken) {
    sessionStorage.setItem(TOKEN_KEY, accessToken);
  }
}

export function getImpersonationAccessToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function clearImpersonationSession() {
  sessionStorage.removeItem(META_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}

export function isImpersonating() {
  return Boolean(getImpersonationMeta());
}

export const IMPERSONATION_EXPIRED_EVENT = 'impersonation:expired';

export function dispatchImpersonationExpired() {
  window.dispatchEvent(new CustomEvent(IMPERSONATION_EXPIRED_EVENT));
}
